export enum ExamEndingType {
    Duration = 0,
    EndDate = 1
}
